import Utils from '../utils/util';
import { scanAllCubes } from './scanAllCube';

function update() {
    scanAllCubes();
}

const updateAllAsync: (...args: any[]) => void = Utils.debounce(update, 10);
const updateAllSync: (...args: any[]) => void = update;

export {
    updateAllAsync,
    updateAllSync,
};
